import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpRequest } from "@angular/common/http";

import { Observable, Subject, BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import {AppSettings} from '../common/app.settings';
import {BaseService} from './base.service'
import { environment } from 'src/environments/environment';
import { buildInfo } from "../../build";

@Injectable()
export class AuthenticationService extends BaseService{
    public token: string;

    //variables from app.component -- start
    serverRevision:any=false;

    //private users:Observable<any>; 
    
    logIn$: Subject<boolean> = new BehaviorSubject<boolean>(false);
    timeout$: Subject<boolean> = new BehaviorSubject<boolean>(false);
    //private logIn = new Subject<boolean>();
    constructor(http: HttpClient) {
        super(http);
        this.logIn$.next(false);
    }
    public setIsLoggedIn(loggedIn:boolean){
        this.logIn$.next(loggedIn);
    }
    public getTimeOut(): Observable<boolean>{
        return this.timeout$.asObservable();
    }
    public setTimeOut(timeout:boolean){
        this.timeout$.next(timeout);
    }
    public getIsLoggedIn(): Observable<boolean>{
        return this.logIn$.asObservable();
    }
    public clearCache()
    {
        super.clearCache();
        this.token = null;
        this.setIsLoggedIn(false);
    }
    confirmInvitation(invitationcode,password, confirmpassword) {
        var params = JSON.stringify({invitation:invitationcode, password: password, password1: confirmpassword });
        var api = AppSettings.VV_INVITE_CONFIRM_EP;
        return this.http.post(`${AppSettings.API_ENDPOINT}${api}`, params)
            .pipe(map((response: any) => {
                return response;
            }));
    }
    changePassword() {
        var api = AppSettings.VV_CHANGE_PASSWORD_EP;
        return this.http.get(`${AppSettings.API_ENDPOINT}${api}`)
            .pipe(map((response: any) => {
                return response;
            }));
    }
    forgotPassword(username) {
        var params = JSON.stringify({email:username});
        var api = AppSettings.VV_FORGOT_PASSWORD_EP;
        return this.http.post(`${AppSettings.API_ENDPOINT}${api}`, params)
            .pipe(map((response: any) => {
                return response;
            }));
    }
    login(username, password) {
        var params = JSON.stringify({ email: username, password: password });
        var api = AppSettings.VV_LOGIN_EP;
        return this.http.post(`${AppSettings.API_ENDPOINT}${api}`, params)
            .pipe(map((response: any) => {
                let token = response.vid;
                if (token) {
                    // set token property
                    this.token = token;
                    let root = response.root;
                    let client = response.client;
                    let isFormEnabled = response.form;
                    let isViewerEnabled = response.viewer;
                    let modules = "core;";
                    if(isFormEnabled){
                        modules = modules + "forms;";
                        if(this.isFormsEditorEnabled(client))
                            modules = modules + "formseditor;"
                    }
                    if(isViewerEnabled)
                        modules = modules + "viewer;"
                    this.setIsLoggedIn(true);
                    // store username and jwt token in local storage to keep user logged in between page refreshes
                    sessionStorage.setItem('vvuser', JSON.stringify({vid: token, root: root, client: client, modules: modules, email: username}));
                    // return true to indicate successful login
                } else {
                    // return false to indicate failed login
                    this.setIsLoggedIn(false);
                }
            }));
    }
    isFormsEditorEnabled(client:string){
        if(environment.formsEditorClients){
            let clientsArray = environment.formsEditorClients.split(";");
            for (let e in clientsArray){
                if(clientsArray[e] == client)
                    return true;
            }
        }
        else
            return false;
    }
    getViewerURL()
    {
        let vvuser = sessionStorage.getItem('vvuser');
        if(vvuser)
        {
            let vvusserObj = JSON.parse(vvuser)
            return vvusserObj.viewer_url;
        }  
        else
            return AppSettings.URL_ENDPOINT;
    }
    setViewerUrlInSession(url)
    {
        let vvuser = sessionStorage.getItem('vvuser');
        if(vvuser)
        {
            url = this.stripTrailingSlash(url);
            let vvusserObj = JSON.parse(vvuser)
            sessionStorage.setItem('vvuser', JSON.stringify({vid: vvusserObj.vid, root: vvusserObj.root, client: vvusserObj.client, modules: vvusserObj.modules, email: vvusserObj.email, viewer_url: url}));
        }
    }
    stripTrailingSlash(str) {
        if(str.substr(-1) === '/') {
            return str.substr(0, str.length - 1);
        }
        return str;
    }
    getClientName()
    {
        const currentUser = JSON.parse(sessionStorage.getItem('vvuser'));
        if(currentUser)
            return currentUser.client;
        else
            return '';
    }
    getDashboardVID()
    {
        if(this.getIsLoggedIn)
        {
            let vvuser = sessionStorage.getItem('vvuser');
            if(vvuser)
            {
                let vvusserObj = JSON.parse(vvuser)
                return vvusserObj.vid;
            }
            else
                return "";
        }
        else
            return "";
    }
    getModuleForPath(path)
    {
        if(path == 'viewerconfig')
            return 'viewer';
        if(path == 'forms')
            return 'forms';
        if(path == 'formseditor')
            return 'formseditor';
        else
            return 'core';
        
    }
    isModuleEnabled(path)
    {
        let moduleName = this.getModuleForPath(path);
        if(moduleName == '')
            return false;
            if(this.getIsLoggedIn)
            {
                let vvuser = sessionStorage.getItem('vvuser');
                if(vvuser)
                {
                    let vvusserObj = JSON.parse(vvuser)
                    let modules = vvusserObj.modules;
                    let modulesArray = modules.split(";");
                    for (let e in modulesArray){
                        if(modulesArray[e] == moduleName)
                            return true;
                    }
                    return false;
                }
                else
                    return false;
            }
            else
                return false;

    }
    logout() {
        var api = AppSettings.VV_LOGOUT_EP;
        return this.http.delete(`${AppSettings.API_ENDPOINT}${api}`)
            .pipe(map((response: Response) => {
                this.clearCache();
                sessionStorage.removeItem('vvuser');
            }));
    }
    
    downloadConfigLocale(locale:string,tenant) {
        var api = AppSettings.VV_CONFIG_LOCALE_EP+locale;
        if(tenant && tenant!='')
            api = api + "/" + tenant;
        /*return this.http.get(`${AppSettings.API_ENDPOINT}${api}`)
                .pipe().map((
                    response: Response) => response);*/
            return this.http
            .get(`${AppSettings.API_ENDPOINT}${api}`,{ responseType: 'text'});

        }
        deleteConfigLocale(locale:string,tenant:string) {
            var api = AppSettings.VV_CONFIG_LOCALE_EP+locale;
            if(tenant && tenant!='')
                api = api + "/" + tenant;
            return this.http.delete(`${AppSettings.API_ENDPOINT}${api}`)
                .pipe(map((response: Response) => {
                }));
        }
        saveConfigLocale(fileToUpload: File, model:any)
	{
		const currentUser = JSON.parse(sessionStorage.getItem('vvuser'));
        var endpoint = AppSettings.VV_CONFIG_LOCALE_EP + model.locale;
        if(model.tenant && model.tenant!='')
        endpoint = endpoint + "/" + model.tenant;
		const formData: FormData = new FormData();
		formData.append('file', fileToUpload, fileToUpload.name);
		formData.append('vid',model.vid);
        let headers = new Headers();
		headers.append('Content-Type', 'multipart/form-data');
		headers.append('Accept', 'application/json');
		headers.append('vid', currentUser.vid);
		const req = new HttpRequest('POST', `${AppSettings.API_ENDPOINT}${endpoint}`, formData);
		return this.http.request(req);
	}
    generateClientSecret(tenantid)
    {
        var api = AppSettings.VV_GENERATE_CLIENT_SECRET_EP;
        if(tenantid)
            api = api + "/" + tenantid;
        var params = {};
        return this.http.post(`${AppSettings.API_ENDPOINT}${api}`, params,{'headers':null})
        .pipe(map((response: any) => {
            return response;
        }));
    }
    editForm(model): Observable<Object> {
        var params = JSON.stringify(model);
        var endpoint = AppSettings.VV_FORM_EDIT_EP;
        return this.http
            .post(`${AppSettings.API_ENDPOINT}${endpoint}`, params,{'headers':null})
            .pipe(map((response: any) => {
                return response;
            }));
    }  
    editGlobalForm(model,action): Observable<Object> {
        var params = {};
        var endpoint = AppSettings.VV_GLOBAL_FORMS_EDIT_EP;
        endpoint = endpoint + "/" + model.template_id;
        if(model.tenant_id!='' && model.tenant_id!='undefined')
            endpoint = endpoint + "/?tenant="+model.tenant_id;
        if(action =="delete")
            endpoint = endpoint +"&deleted=true";
        if(action =="activate")
            endpoint = endpoint +"&inactive=false";
        if(action =="deactivate")
            endpoint = endpoint +"&inactive=true";
        return this.http
            .post(`${AppSettings.API_ENDPOINT}${endpoint}`, params,{'headers':null})
            .pipe(map((response: any) => {
                return response;
            }));
    }  
    publishForm(fid): Observable<Object> {
        var endpoint = AppSettings.VV_FORM_PUBLSIH_EP;

        const headers = new HttpHeaders()
        .set('fid', fid)
        .set('vid', this.getDashboardVID())
        .set('X-VV-REQUEST','X-VV-REQUEST');
        return this.http
            .post(`${AppSettings.API_ENDPOINT}${endpoint}`,null,{'headers':headers,'responseType': 'text'})
            .pipe(map((response: any) => {
                return response;
            }));
    }  
    exportForm(model): Observable<Object> {
        var endpoint = AppSettings.VV_FORM_EXPORT_EP;
        var params = JSON.stringify(model);
        return this.http
            .post(`${AppSettings.API_ENDPOINT}${endpoint}`, params,{ responseType: 'blob'})
            .pipe(map(response => new Blob([response], {type: 'application/zip'})));
    }  
    exportGlobalForm(model): Observable<Object> {
        var endpoint = AppSettings.VV_GLOBAL_FORM_EXPORT_EP;
        endpoint = endpoint + "/" + model.template_id+"?tenant="+model.tenant_id;
        //var params = JSON.stringify(model);
        return this.http
            .get(`${AppSettings.API_ENDPOINT}${endpoint}`,{ responseType: 'blob'})
            .pipe(map(response => new Blob([response], {type: 'application/zip'})));
    }  
    getClientBuild()
    {
        var buildArray:string[] =[];
        
            let buildtimestamp = buildInfo.timestamp;
            let buildDate:any = Date.parse(buildtimestamp);
            var bdate = new Date(buildDate);
            
            //console.log(bdate.getDate() + '/' + (bdate.getMonth()+1) + '/' + bdate.getFullYear());
            let bdatestring =  (bdate.getMonth()+1) +  '/' +  bdate.getDate() + '/' + bdate.getFullYear();
            var month = (bdate.getMonth()+1);
            let version = "";
            if(environment.production)
                version = environment.appVersion + "." + bdate.getFullYear().toString().substr(-2) + "." + month;
            else
                version = environment.appVersion + "." + bdate.getFullYear().toString().substr(-2) + "." + month + "-dev";;
            buildArray.push(bdatestring);
            buildArray.push(version);
            return buildArray;
    }
    getServerBuild()
    {
        if(!this.serverRevision){
        var api = AppSettings.VV_SERVER_VERSION_EP;
        var buildArray:string[] =[];
        return this.http.get(`${AppSettings.API_ENDPOINT}${api}`)
            .pipe(map((response: any) => {
            let buildtimestamp = response.date;
            let buildDate:any = Date.parse(buildtimestamp);
            var bdate = new Date(buildDate);
            let bdatestring =  (bdate.getMonth()+1) +  '/' +  bdate.getDate() + '/' + bdate.getFullYear();
            var month = (bdate.getMonth()+1);
            let version = "";
            if(environment.production)
                version =  environment.appVersion + "." + bdate.getFullYear().toString().substr(-2) + "." + month;
            else
                version =  environment.appVersion + "." + bdate.getFullYear().toString().substr(-2) + "." + month+ "-dev";;
            buildArray.push(bdatestring);
            buildArray.push(version);
            this.serverRevision = buildArray;
            return this.serverRevision;
        }));
    }
    else
        return this.serverRevision
    }
}